// import axios from '../utils/AxiosInstance'
import moment from 'moment'

export default {
  // namespaced: true,
  state: {
    reportingFilters: {
      date: [moment().subtract(30, 'days').toISOString(), moment().toISOString()]
    }
  },
  mutations: {
    SET_REPORTING (store, val) {
      store.reportingFilters = val
    }
  },
  getters: {
    getReportingFilters: (store) => {
      return store.reportingFilters
    }
  },
  actions: {
    setReportingFilter ({commit, dispatch, getters}, data) {
      commit('SET_REPORTING', data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/ReportingFilters.js